import React, {CSSProperties, useEffect, useRef} from 'react'

import {SlotComponent} from '../../../types/ui'
import {Stack, Text} from '../../../vanilla'
import {CmsImage} from '../cms-image'
import {CTAButton} from '../../../vanilla/components/CTAButton'
import {useSelectPromotionTracking, usePromotionDataTracking} from '../../../analytics/promotion-tracking'
import {ChevronRightIcon} from '../../icons'
import {isMobile} from '../../../utils/utils'
import { OfferCardCmsContent } from '../../../types/cms'
import { createPromoForSelectPromotion } from '../../../analytics/utils'
import { offerCardSubtitle } from './styles.css'
import { CampaignCMSContent } from '../../../types/cms/campaign'
import { useIntersectionObserver } from '../../../hooks/use-intersection-observer'

export const OfferCard: SlotComponent<
  OfferCardCmsContent,
  {styles?: CSSProperties; size?: number, index?: number, isOfferCards?: boolean, offerCardsSlotGroupName?: string, slotGroupName?: string, slotIndex?: number, campaign?: CampaignCMSContent}
> = ({content, styles, index, offerCardsSlotGroupName, slotGroupName, slotIndex, campaign}) => {
  const {image, imageLink, title, cta} = content
  const sendPromotionData = usePromotionDataTracking()
  const ref = useRef<HTMLDivElement | null>(null)

  // Create object for select_promotion event
  const selectPromoInfo = {
    content,
    slotGroupName: offerCardsSlotGroupName ?? slotGroupName,
    slotPosition: slotIndex,
    campaign,
    index
  }
  const viewPromoItem = {
    ...content,
    slotGroupName: offerCardsSlotGroupName ?? slotGroupName,
    slotIndex
  }

  const { isOnScreen: isTrueView } = useIntersectionObserver(ref, {
    useOnce: true,
    rootMargin: '0px -70px 0px 0px'
  })

  const promotion = createPromoForSelectPromotion(selectPromoInfo)

  useEffect(() => {
    if (isTrueView) {
      sendPromotionData([[viewPromoItem]])
    }
  }, [isTrueView])

  const sendSelectPromotion = useSelectPromotionTracking()
  const isMobileFlag: boolean = isMobile()

  return (
    <Stack gap="0px" style={styles} borderRadius="medium" overflow="hidden" ref={ref}>
      <CmsImage
        queryParams={[
          {w: 1752, fmt: 'auto', qlt: 'default'}, 
          {w: 3504, fmt: 'auto', qlt: 'default'}
        ]}
        images={image.images}
        width="full"
        height="auto"
        imageLink={imageLink}
        linkProps={{display: 'block', style: {fontSize: 0}}}
        onClickCapture={() => {
          sendSelectPromotion(promotion)
        }}
      />
      {title || cta?.ctaText ? (
        <Stack
          direction={'row'}
          paddingY={['16px', '20px', '32px']}
          paddingX={['16px', '40px', '24px']}
          backgroundColor="white"
          alignItems="center"
          gap="8px"
          flexGrow="1"
        >
          {title && (
            <Text
              className={offerCardSubtitle}
            >
              {title}
            </Text>
          )}
          {isMobileFlag ?
            <ChevronRightIcon
              boxSize="12px"
              onClickCapture={() => {
                sendSelectPromotion(promotion)
              }}
              /> : cta?.ctaText && (
              <CTAButton
                cta={cta}
                onClickCapture={() => {
                  sendSelectPromotion(promotion)
                }}
              />
            )}
        </Stack>
      ) : null}
    </Stack>
  )
}
